import { ICommand, Topics } from '@zaplify/common';
import { PersonFilterDto } from '../dtos';

export class ClonePersonFilterCommand extends ICommand<PersonFilterDto> {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly sourceId: string, readonly userId: string, readonly userOrganizationId: string) {
        super();
    }
}
